// extracted by mini-css-extract-plugin
export default {"outer":"IFrame_outer__qpIq1","inner":"IFrame_inner__RUL3j","content":"IFrame_content__LlBau"};